import React from 'react';
import classNames from 'classnames';
import { TooltipLazy } from '../tooltip-lazy/tooltip-lazy';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import { useApi } from '../../context/api-context/use-api';
import { getIsMobile } from '../../../common/store/base-params/base-params-selectors';
import { ACTIVE, DOWNVOTE_BUTTON, PENDING, UPVOTE_BUTTON, VOTE_CONTAINER, VOTE_COUNT, DISABLED, } from '../../../common/constants/data-hooks';
import VoteArrow from './vote-arrow/vote-arrow';
import { VoteArrowIcon } from '../icons/vote-arrow-icon';
import { classes, st } from './voting.st.css';
const Voting = ({ onVote, voteState, disabled, className }) => {
    const isMobile = useApi((state) => getIsMobile(state));
    const t = useTranslate();
    const tooltipProps = {
        minWidth: 100,
        showDelay: 1000,
        disabled: isMobile,
        appendTo: 'window',
    };
    return (React.createElement("div", { "data-hook": classNames(VOTE_CONTAINER, voteState.pending && PENDING, disabled && DISABLED), className: st(classes.root, { isDisabled: disabled }, className) },
        React.createElement(TooltipLazy, Object.assign({}, tooltipProps, { content: React.createElement("div", { style: { textAlign: 'center' } }, voteState.state === 'UPVOTE'
                ? t('voting.unupvote-tooltip')
                : t('voting.upvote-tooltip')), disabled: disabled }), (() => {
            const isActive = voteState.state === 'UPVOTE';
            return (React.createElement(VoteArrow, { className: st(classes.vote, { isActive }), dataHook: classNames(UPVOTE_BUTTON, isActive && ACTIVE), onClick: () => !disabled && onVote(isActive ? 'NEUTRAL' : 'UPVOTE'), active: isActive, component: React.createElement(VoteArrowIcon, null), disabled: disabled }));
        })()),
        React.createElement("span", { className: classes.voteCount, "data-hook": VOTE_COUNT }, voteState.score),
        React.createElement(TooltipLazy, Object.assign({}, tooltipProps, { content: React.createElement("div", { style: { textAlign: 'center' } }, voteState.state === 'DOWNVOTE'
                ? t('voting.undownvote-tooltip')
                : t('voting.downvote-tooltip')), disabled: disabled }), (() => {
            const isActive = voteState.state === 'DOWNVOTE';
            return (React.createElement(VoteArrow, { className: st(classes.vote, { isActive }), dataHook: classNames(DOWNVOTE_BUTTON, isActive && ACTIVE), onClick: () => !disabled && onVote(isActive ? 'NEUTRAL' : 'DOWNVOTE'), active: isActive, component: React.createElement(VoteArrowIcon, null), flip: true, disabled: disabled }));
        })())));
};
export default Voting;
//# sourceMappingURL=voting.js.map